import unhead_KgADcZ0jPj from "/usr/src/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/usr/src/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/usr/src/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/usr/src/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/usr/src/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/usr/src/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/usr/src/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_033erZNTtF from "/usr/src/app/packages/gtm/src/plugin.js";
import plugin_8SbxDRbG6Y from "/usr/src/app/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/usr/src/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import apm_client_2SC0aN2UhS from "/usr/src/app/client/plugins/apm.client.js";
import cookies_YKMB08GTSU from "/usr/src/app/client/plugins/cookies.ts";
import api_client_bwJoOTwWPq from "/usr/src/app/client/plugins/api.client.js";
import init_app_AXG0B2aUky from "/usr/src/app/client/plugins/init.app.ts";
import gun_client_YgOQy5Ez5D from "/usr/src/app/client/plugins/gun/gun.client.js";
import analytics_QbJSlyDPU6 from "/usr/src/app/client/plugins/analytics.js";
import vue_double_raf_client_3nm0s3hrC7 from "/usr/src/app/client/plugins/vue-double-raf.client.js";
import libs_client_9jokfgEGAD from "/usr/src/app/client/plugins/libs.client.js";
import warn_handler_rkDGkruD6Z from "/usr/src/app/client/plugins/warn-handler.js";
import attrs_filters_s7Dypq8xc9 from "/usr/src/app/client/plugins/attrs-filters.js";
import bem_class_name_uOEyFHkX1o from "/usr/src/app/client/plugins/bem-class-name.js";
import data_test_id_QM4rZv0eg3 from "/usr/src/app/client/plugins/data-test-id.js";
import dayjs_g3asnNCYsI from "/usr/src/app/client/plugins/dayjs.js";
import dates_cDXZCmBt3W from "/usr/src/app/client/plugins/dates.js";
import media_query_tHxGt7hWCK from "/usr/src/app/client/plugins/media-query.js";
import notifier_dp096yzZJL from "/usr/src/app/client/plugins/notifier.js";
import modules_dAMzPqhXUk from "/usr/src/app/client/plugins/modules.ts";
import i18n_eezmytabiM from "/usr/src/app/client/plugins/i18n.js";
import init_client_C8gEabW6C9 from "/usr/src/app/client/plugins/init.client.js";
import v_clamp_client_pYA8JVZkaD from "/usr/src/app/client/plugins/v-clamp.client.ts";
import vue_scrollto_enyZJ6gmaY from "/usr/src/app/client/plugins/vue-scrollto.js";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_033erZNTtF,
  plugin_8SbxDRbG6Y,
  i18n_yfWm7jX06p,
  apm_client_2SC0aN2UhS,
  cookies_YKMB08GTSU,
  api_client_bwJoOTwWPq,
  init_app_AXG0B2aUky,
  gun_client_YgOQy5Ez5D,
  analytics_QbJSlyDPU6,
  vue_double_raf_client_3nm0s3hrC7,
  libs_client_9jokfgEGAD,
  warn_handler_rkDGkruD6Z,
  attrs_filters_s7Dypq8xc9,
  bem_class_name_uOEyFHkX1o,
  data_test_id_QM4rZv0eg3,
  dayjs_g3asnNCYsI,
  dates_cDXZCmBt3W,
  media_query_tHxGt7hWCK,
  notifier_dp096yzZJL,
  modules_dAMzPqhXUk,
  i18n_eezmytabiM,
  init_client_C8gEabW6C9,
  v_clamp_client_pYA8JVZkaD,
  vue_scrollto_enyZJ6gmaY
]